import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * Gray "Pro" pill badge used to mark scene-lock/upgrade affordances.
 * Any explanatory copy is hover-only (MUI Tooltip), not shown inline.
 */
const ProPill = ({ tooltip, onClick, style = {} }) => (
  <Tooltip title={tooltip || ''} placement="top" disableHoverListener={!tooltip}>
    <span
      className="proPill"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 14px',
        borderRadius: '9999px',
        backgroundColor: '#E5E5E5',
        color: '#6B6B6B',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '20px',
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        ...style,
      }}
    >
      Pro
    </span>
  </Tooltip>
);

export default ProPill;
